<template>
  <div class="table-responsive">
    <table :id="table_id" class="display table table-striped table-bordered" style="width:100%; text-align: center;">
      <thead>
        <tr>
          <th v-for="(header, index) in tableHeader" :key="index">{{ headerLabels[header] || header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, index) in arrayData" :key="index">
          <td v-for="(key, idx) in tableHeader" :key="idx">{{ data[key] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: {
    table_id: {
      type: String,
      default: "table-id"
    },

    arrayData: {
      type: Array,
      default: []
    },
    
    tableHeader: {
      type: Array,
      default: () => ['name', 'ic_number', 'mobile_number']
    }
  },

  data() {
    return {
      headerLabels: {
        name: 'Name',
        ic_number: 'IC Number',
        mobile_number: 'Mobile Number',
        account_number: 'Takaful ID'
      }
    }
  }
}

</script>
